<div class="rc-prompt">
  <button mat-icon-button class="close-btn" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="rc-prompt-content">
    <mat-icon class="rc-icon">phone_in_talk</mat-icon>
    <h2>Connect Your RingCentral Account</h2>
    <p>Your company uses RingCentral for SMS. Connect your account to send messages from your own phone number.</p>

    <div class="rc-prompt-actions">
      <button mat-raised-button color="primary" (click)="connect()">
        <mat-icon>link</mat-icon>
        Connect Now
      </button>
      <button mat-button color="basic" (click)="dismiss()">
        Maybe Later
      </button>
    </div>
  </div>
</div>
